import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import Timestamp from '../../../Timestamp';
import s from './PublishedTime.scss';
var PublishedTime = function (_a) {
    var publishedTime = _a.publishedTime, withoutText = _a.withoutText, className = _a.className;
    if (!publishedTime) {
        return null;
    }
    var timestamp = (React.createElement(Timestamp, { timestamp: publishedTime, showTooltip: true, showFullLengthOnMobile: true }));
    return (React.createElement("span", { className: classnames(s['root'], className) }, withoutText ? (timestamp) : (React.createElement(Trans, { i18nKey: 'deviation.details.publishedTime' },
        "Published: ",
        timestamp))));
};
PublishedTime.displayName = 'PublishedTime';
export default PublishedTime;
//# sourceMappingURL=PublishedTime.js.map